module.exports = __webpack_public_path__ + "static/media/10.37f078b6.jpg";